exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header_tool_cla[data-v-300800b9] .el-tabs__header{margin:0 0 .25rem}.black_panel_cla[data-v-300800b9]{min-height:41.666667rem}[data-v-300800b9] .el-tabs__nav-wrap:after{display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-300800b9","scoped":true,"hasInlineConfig":false}!./node_modules/px2rem-loader?{"remUnit":12}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/statistics/callDetails.vue
// module id = UrlV
// module chunks = 7